import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sevanseatercaronrentinmumbai() {



const cardData = {
  keyword: " 7 Seater Car on Rent in Mumbai",

headingDescription: "Velocity Cab provides reliable and comfortable 7 seater car on rent in Mumbai, offering the perfect travel solution for families, small groups, corporate travel, airport transfers, and outstation journeys. Our well-maintained 7 seater vehicles such as Ertiga, Innova, and similar models come with spacious seating, air-conditioning, and ample luggage space to ensure a comfortable journey. With professional drivers, punctual service, and smooth ride quality, we make traveling across Mumbai and beyond easy and stress-free. We offer flexible booking options including hourly rentals, full-day packages, one-way trips, and customized travel plans with transparent pricing and no hidden charges. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for 7 seater car rental in Mumbai.",

topPlaces: [

  {
    title: "Igatpuri",
    description: "Igatpuri is a serene hill station located in the Western Ghats, known for its lush greenery, waterfalls, and calm environment. It is ideal for meditation retreats, nature walks, and scenic drives through fog-covered mountains."
  },
  {
    title: "Matheran",
    description: "Matheran is India’s smallest hill station and a unique eco-friendly destination near Mumbai. Known for its vehicle-free environment, visitors can explore viewpoints like Panorama Point and Echo Point while enjoying horse rides and walking trails."
  },
  {
    title: "Nashik",
    description: "Nashik is a major pilgrimage and wine tourism destination near Mumbai, famous for the Trimbakeshwar Temple and Sula Vineyards. Travelers can enjoy spiritual visits, vineyard tours, and scenic riverfront experiences along the Godavari River."
  },
    {
    title: "Lonavala",
    description: "Lonavala is one of the most popular outstation destinations from Mumbai, known for its lush green valleys, misty hills, and scenic waterfalls. Travelers booking a sedan cab can enjoy a comfortable drive via the Mumbai–Pune Expressway and visit attractions like Tiger Point, Bhushi Dam, and Lion’s Point for breathtaking views."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a beautiful coastal getaway near Mumbai famous for its clean beaches, sea forts, and relaxed vibe. Visitors can enjoy Alibaug Beach, Kolaba Fort, and Mandwa Jetty while experiencing a peaceful seaside escape perfect for weekend trips."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India’s most important pilgrimage sites dedicated to Sai Baba. Visitors can visit the Sai Baba Samadhi Mandir, Dwarkamai, and Chavadi while experiencing a peaceful spiritual atmosphere."
  },
  {
    title: "Saputara",
    description: "Saputara is a picturesque hill station in Gujarat near the Maharashtra border, known for its cool climate, lakes, and viewpoints. It offers boating, ropeway rides, and scenic sunset spots ideal for family trips."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a charming hill station near Mumbai famous for its strawberry farms, Table Land plateau, and scenic valley views. It is perfect for relaxing holidays and nature photography."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for its cool weather, strawberry farms, and viewpoints like Arthur’s Seat and Elephant’s Head Point. It is ideal for long weekend getaways from Mumbai."
  },
  {
    title: "Kashid Beach",
    description: "Kashid Beach is a peaceful coastal destination near Mumbai known for its white sand, clear waters, and water sports activities. It is a great spot for relaxation, camping, and seaside drives."
  }
],



services: [
{
name: "7 Seater Cab Mumbai",
description: "7 seater cab Mumbai provides a comfortable and spacious travel solution for families and small groups traveling within the city or for outstation trips. These vehicles are ideal for airport transfers, corporate travel, family outings, and weekend getaways. With ample seating space, luggage capacity, and smooth ride quality, 7 seater cabs ensure a relaxed journey for all passengers. Professional drivers with good knowledge of city routes and highways ensure safe and timely travel. Customers can choose flexible rental options including hourly, daily, and outstation packages based on their needs. Pickup is available from all major locations including Mumbai Airport, railway stations, and residential areas. With transparent pricing and easy booking, this service ensures convenience, comfort, and reliability."
},
{
name: "7 Seater Taxi Mumbai",
description: "7 seater taxi Mumbai offers reliable and comfortable transportation for families and groups who need extra seating space. This service is suitable for city travel, airport transfers, and long-distance journeys. Vehicles are well-maintained with comfortable interiors to ensure a smooth ride. Professional drivers ensure safe and efficient travel across all routes. Flexible booking options make it easy for customers to plan trips. It is a popular choice for group travel in Mumbai."
},
{
name: "7 Seater Car Rental Mumbai",
description: "7 seater car rental Mumbai provides flexible travel options for customers who need spacious vehicles for personal or business use. This service is ideal for family trips, corporate travel, and group outings. Customers can choose rental plans based on duration and distance. Well-maintained vehicles and professional drivers ensure a comfortable journey. Flexible pickup and drop options add convenience. It is a reliable choice for group transportation."
},
{
name: "Cheap 7 Seater Cab Mumbai",
description: "Cheap 7 seater cab Mumbai offers budget-friendly travel options without compromising on comfort and safety. This service is ideal for cost-conscious travelers who need spacious vehicles at affordable rates. Economical pricing and transparent billing ensure no hidden charges. Professional drivers ensure safe and smooth travel. Flexible rental plans are available for different needs. It is a perfect combination of affordability and comfort."
},
{
name: "SUV 7 Seater Cab Mumbai",
description: "SUV 7 seater cab Mumbai is ideal for travelers who prefer extra comfort, power, and space during their journey. SUVs provide better road grip and spacious seating, making them perfect for both city and outstation travel. This service is suitable for families, groups, and corporate travelers. Professional drivers ensure safe driving on highways and city roads. It offers a premium and comfortable travel experience. Ideal for long-distance journeys."
},
{
name: "7 Seater Cab for Outstation Mumbai",
description: "7 seater cab for outstation Mumbai provides long-distance travel solutions with comfort and reliability. This service is ideal for trips to Pune, Lonavala, Nashik, Shirdi, and other destinations. Spacious seating and smooth ride quality make long journeys comfortable. Professional drivers ensure safe driving on highways and ghat roads. Flexible packages include one way and round trip options. It ensures a hassle-free travel experience."
},
{
name: "7 Seater Airport Cab Mumbai",
description: "7 seater airport cab Mumbai offers reliable and comfortable airport transfer services for families and groups with luggage. This service ensures timely pickup and drop at Mumbai Airport with spacious seating. Drivers track flight timings to avoid delays. Clean and well-maintained vehicles enhance the travel experience. Flexible booking options are available. It ensures a smooth and stress-free airport journey."
},
{
name: "7 Seater Taxi Booking Mumbai",
description: "7 seater taxi booking Mumbai allows customers to easily reserve spacious taxis with instant confirmation and flexible scheduling. Online booking platforms provide quick and hassle-free reservations. Customers can select pickup location, travel date, and vehicle type conveniently. Transparent pricing ensures no hidden costs. Dedicated support is available for assistance. It is the easiest way to book a 7 seater taxi."
},
{
name: "Private 7 Seater Cab Mumbai",
description: "Private 7 seater cab Mumbai offers a personalized travel experience with exclusive vehicle usage for families and groups. Travelers can customize routes, stops, and travel schedules based on their needs. This ensures a relaxed and stress-free journey. Professional drivers provide safe and reliable service. Comfortable seating and clean interiors enhance the experience. It is ideal for private and comfortable travel."
},
{
name: "AC 7 Seater Taxi Mumbai",
description: "AC 7 seater taxi Mumbai ensures a comfortable journey in air-conditioned vehicles for both city and long-distance travel. This service is ideal for families and groups who prefer a pleasant travel environment. Clean interiors and well-maintained AC systems enhance passenger comfort. Flexible pickup options add convenience. Professional drivers ensure timely and safe service. It guarantees a relaxing and enjoyable travel experience."
}
],

tableData: [
["7 Seater Cab Mumbai","7 Seater Taxi Mumbai"],
["7 Seater Car Rental Mumbai","Cheap 7 Seater Cab Mumbai"],
["SUV 7 Seater Cab Mumbai","7 Seater Cab for Outstation Mumbai"],
["7 Seater Airport Cab Mumbai","7 Seater Taxi Booking Mumbai"],
["Private 7 Seater Cab Mumbai","AC 7 Seater Taxi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Perfect 7 Seater for Family Travel",
    WhyChoosedescription: "Velocity Cabs offers 7 seater car on rent in Mumbai ideal for families and small groups, providing spacious seating and comfortable travel for city and outstation journeys."
  },
  {
    WhyChooseheading: "Experienced Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Mumbai city routes and highways, ensuring safe driving, smooth journeys, and timely pickups and drop-offs."
  },
  {
    WhyChooseheading: "Transparent Rental Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent and affordable pricing for 7 seater car rental in Mumbai. Customers receive complete fare details including per km charges, tolls, and driver allowance."
  },
  {
    WhyChooseheading: "24/7 Rental Availability",
    WhyChoosedescription: "Our 7 seater car rental service in Mumbai operates 24/7. Whether for airport transfer, business travel, or late-night rides, we ensure reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All 7 seater vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and stress-free travel experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers 7 seater vehicles like Ertiga, Innova, and Kia Carens, suitable for family trips, airport transfers, and group travel."
  },
  {
    WhyChooseheading: "Flexible Rental Options",
    WhyChoosedescription: "We offer flexible booking options including local packages (8 hours/80 km), outstation trips, one-way travel, and round-trip bookings based on your requirements."
  },
  {
    WhyChooseheading: "Trusted Car Rental Service in Mumbai",
    WhyChoosedescription: "Velocity Cabs is trusted by many customers for 7 seater car rental in Mumbai due to professional drivers, clean vehicles, and reliable service quality."
  }
]
};

const faqData = [
  { question: "Do you provide 7 seater car on rent in Mumbai?", answer: "Yes, Velocity Cabs provides 7 seater car rental services in Mumbai for local and outstation travel." },
  { question: "Which 7 seater cars are available?", answer: "We offer vehicles like Ertiga, Innova, Kia Carens, and similar 7 seater cars for comfortable travel." },
  { question: "What is the price of 7 seater car rental in Mumbai?", answer: "Rental cost typically starts from ₹14 to ₹20 per km or ₹2500 to ₹4500 per day depending on vehicle type and package." },
  { question: "Is 7 seater car available for airport transfers?", answer: "Yes, we provide airport pickup and drop services in Mumbai using 7 seater vehicles." },
  { question: "Can I book 7 seater car for outstation trips?", answer: "Yes, 7 seater cars are available for outstation travel from Mumbai to destinations like Pune, Shirdi, Goa, Mahabaleshwar, and Nashik." },
  { question: "Is rental service available 24 hours?", answer: "Yes, our 7 seater car rental service in Mumbai operates 24/7." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all 7 seater vehicles are fully air-conditioned and well maintained." },
  { question: "Can I book 7 seater car online?", answer: "Yes, customers can easily book 7 seater car on rent in Mumbai online or through phone booking." },
  { question: "Is driver included in the rental?", answer: "Yes, all rentals include professional drivers for safe and comfortable travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Deshpande",
    feedback:
      "We rented a 7 seater car from Velocity Cabs for our family trip, and the experience was outstanding. The vehicle was spacious, clean, and made our journey comfortable from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "Velocity Cabs provided us with a well-maintained 7 seater car on rent for our weekend travel. The driver was courteous, the pickup was punctual, and everyone enjoyed a smooth ride.",
    rating: 5
  }
];
























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];




const sevenSeaterMumbaiJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "7 Seater Car On Rent in Mumbai | Velocity Cabs",
  "description": "Rent a 7 Seater car in Mumbai for airport pickups, outstation trips, or city travel. AC and SUV options with driver available at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "7 Seater Car Rental Packages in Mumbai",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way 7 Seater Rental",
        "description": "Rent a 7 Seater car for one-way travel in Mumbai with AC/SUV options and private driver.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip 7 Seater Rental",
        "description": "Comfortable round-trip rental of 7 Seater cars in Mumbai with private driver and AC/SUV options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};












  return (
    <div>
      

<Helmet>
  <title>7 Seater Car On Rent in Mumbai | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Rent a 7 Seater car in Mumbai for airport pickups, outstation trips, or city travel. AC and SUV options with driver available at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(sevenSeaterMumbaiJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/89.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sevanseatercaronrentinmumbai;